<template>
    <section class="container-fluid c-footer">
        <div class="ft1">
            <div class="container">
                <div class="row">
                    <div class="col-24 col-sm-16 main-left">
                        <div class="logo">
                            <div class="item"><img src="@/assets/images/footer-logo-1.png" alt=""></div>
                            <div class="item"><img src="@/assets/images/footer-logo-2.png" alt=""></div>
                            <div class="item"><img src="@/assets/images/footer-logo-3.png" alt=""></div>
                        </div>
                        <div class="other">
                            <b>技术支持：</b>
                            科技云运行与技术发展部 <a href="mailto:cstcloud@cnic.cn">cstcloud@cnic.cn</a>
                        </div>
                        <div class="as">
                          <router-link to="/rule?ctgid=29&id=136">管理与规范</router-link> |
                          <router-link to="/case?ctgid=38">项目与案例</router-link> |
                          <router-link to="/news?ctgid=66">用户培训</router-link> |
                          <router-link to="/about?ctgid=58&id=170">关于我们</router-link>
                        </div>
                    </div>
                    <div class="col-24 col-sm-8 main-right">
                        <h3>关注我们</h3>
                        <div class="code-box">
                            <div class="item"><img src="@/assets/images/footer-code-1.png" alt=""></div>
                            <div class="item"><img src="@/assets/images/footer-code-2.png" alt=""></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ft2">
            <div class="container">
                <div class="cpt">
                    1996-2025中国科学院计算机网络信息中心&nbsp;版权所有&nbsp;&nbsp;<a href="">京公安网备11010802030547号</a>&nbsp;&nbsp;<a href="">京ICP备09112257号-94</a>
                </div>
                <div class="an">
                    <a href="" class="item"><img src="@/assets/images/footer-icon-1.png" alt="" class="uc-icon50"></a><a href="" class="item"><img src="@/assets/images/footer-icon-2.png" alt="" class="uc-icon50"></a>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
    import { ref } from 'vue'
    const name = ref('小')
</script>